import axios from 'axios/index';
import { ApiService } from '../utils/string';
import WebSocketService from './WebSocketService';

class MenuRepository {
  URL: string;

  constructor() {
    this.URL = `${process.env.REACT_APP_API_SERVICE_HOST}`;
  }

  fetch(params: any) {
    if (WebSocketService.isConnected()) {
      return WebSocketService.send('/common/w_xusers/action/retrieve', params);
    }

    return axios.post(
      `${this.URL}${ApiService.make(
        'common',
        'w_xusers',
        'action',
        'retrieve',
      )}`,
      params,
    );
  }
}

export default new MenuRepository();
